'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$14() {
  this.bb6 = null;
  this.bb7 = false;
}
export { $c_Lpresto_Presto$$anon$14 as $c_Lpresto_Presto$$anon$14 };
$p = $c_Lpresto_Presto$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$14;
/** @constructor */
function $h_Lpresto_Presto$$anon$14() {
}
export { $h_Lpresto_Presto$$anon$14 as $h_Lpresto_Presto$$anon$14 };
$h_Lpresto_Presto$$anon$14.prototype = $p;
$p.P = (function() {
  if ((!this.bb7)) {
    this.bb6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bb7 = true;
  }
  return this.bb6;
});
var $d_Lpresto_Presto$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$14, "presto.Presto$$anon$14", ({
  N9: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_Presto$$anon$14 as $d_Lpresto_Presto$$anon$14 };
//# sourceMappingURL=presto.-Presto$$anon$14.js.map
